import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toast } from '@/hooks/use-toast';
import { useQueryClient } from '@tanstack/react-query';
import { useCreateContact } from '@/hooksApi/useContact';
import ContactForm, { EMPTY_CONTACT_FORM, buildPayload } from './ContactForm';
import type { ContactFormState } from './ContactForm';

const SettingsAddressBookNew = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { mutate: createContact, isLoading: isCreating } = useCreateContact();

  const handleSave = (form: ContactFormState) => {
    const payload = buildPayload(form);
    createContact(payload, {
      onSuccess: () => {
        toast({ title: t('success_title'), description: t('contact_added') });
        queryClient.invalidateQueries(['contacts']);
        navigate('/settings/address-book');
      },
      onError: (error: any) => {
        const msg = error?.response?.data?.message || error?.message || t('operation_failed');
        toast({ title: t('error_title'), description: msg, variant: 'destructive' });
      },
    });
  };

  return (
    <ContactForm
      heading={t('new_contact')}
      initialForm={EMPTY_CONTACT_FORM}
      isSaving={isCreating}
      onSave={handleSave}
    />
  );
};

export default SettingsAddressBookNew;
